export default __webpack_public_path__ + "static/media/logo1.3e34cbd1.svg";